import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class StatementsCheckConfiguration  {
    _originalTypeClassName = "zERP.BO.StatementsCheckConfiguration";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
StatementsCheckConfiguration.translate = translateService;
}
this.Bank = new Domain.Bank();
this.Id = null;
this.TransactionCode = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TransactionCode:any;
Bank:any;
static setBank = ($this, value) => {
var oldValue = $this.Bank;
$this.Bank = value;
if (value != null) {
if (oldValue != null) {
Domain.Bank.removeStatementsCheckConfiguration(oldValue, $this);
}
Domain.Bank.addStatementsCheckConfiguration(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}